import React, { ReactElement, useState, ChangeEvent } from 'react'

import { useNavigate } from 'react-router-dom'
import { RichTextEditor } from '@mantine/rte'
import {
  PopUp,
  EditCard,
  StyledIcon,
  StyledInputs,
  StyledInput,
} from '../../styled-components'

import { addTraining, updateTraining } from '../../../../api/training'
import { Training } from '../../../../types/training'
import Icon from '../../../icon'
import { Alert } from '../../../../constants/sweet-alert'
import Inputfield from '../../../input/input-field'
import Button from '../../../button'
import TickBox from '../../../input/tick-box'

interface TrainingAddEditProps {
  training: Training | Omit<Training, 'categories'>
  trainingGroupId: string
  onClose: () => void
}

const TrainingAddEdit = ({
  training,
  onClose,
  trainingGroupId,
}: TrainingAddEditProps): ReactElement => {
  const [title, setTitle] = useState(training.title)
  const [code, setCode] = useState(training.code)
  const [isVisible, setIsVisible] = useState(training.isVisible)
  const [loading, setLoading] = useState(false)

  const [description, setDescription] = useState(training.description)

  const navigate = useNavigate()

  const onEditSave = () => {
    setLoading(true)
    const payload = {
      title,
      code,
      isWhat: training.isWhat,
      description,
      isVisible,
    }
    updateTraining(training.id, payload).then((status) => {
      setLoading(false)
      if (status === 200) {
        Alert.fire({
          icon: 'success',
          title: `Updated`,
        })
        navigate(0)
      } else {
        setLoading(false)
        Alert.fire({
          icon: 'error',
          title: `Error`,
        })
      }
    })
  }

  const onAddSave = () => {
    if (description) {
      setLoading(true)
      const payload = {
        training: {
          title,
          code,
          isWhat: training.isWhat,
          description,
          isVisible,
        },
        trainingGroupId,
      }

      addTraining(payload).then((status) => {
        if (status === 201) {
          setLoading(false)
          Alert.fire({
            icon: 'success',
            title: `Created`,
          })
          navigate(0)
        } else {
          setLoading(false)
          Alert.fire({
            icon: 'error',
            title: `Error`,
          })
        }
      })
    }
  }

  return (
    <PopUp>
      <EditCard>
        <StyledIcon onClick={onClose}>
          <Icon name={'cil:x'} color="darkRed" width={20} height={20} />
        </StyledIcon>
        <Inputfield
          value={title}
          labelName="العنوان"
          onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
            setTitle(event.target.value)
          }
          type="text"
        />
        <StyledInputs>
          <StyledInput>
            <Inputfield
              value={code}
              labelName="الرمز"
              onValueChange={(event: ChangeEvent<HTMLInputElement>) =>
                setCode(event.target.value)
              }
              type="text"
            />
            <TickBox
              text="ممكن رؤيته"
              defaultChecked={isVisible}
              id={NaN}
              onValueChange={(event) => setIsVisible(event.target.checked)}
            />
          </StyledInput>
        </StyledInputs>
        <RichTextEditor
          dir="rtl"
          value={description}
          onChange={setDescription}
        />

        <Button
          loading={loading}
          onClick={training.id ? onEditSave : onAddSave}
          color="red"
        >
          <Icon name="entypo:check" />
        </Button>
      </EditCard>
    </PopUp>
  )
}

export default TrainingAddEdit
